const ENDPOINT = '/api/client/web-event';
const RETRY_LIMIT = 3;
const REQUEST_OPTIONS = {
    headers: {
        'Content-Type': 'application/json'
    },
    method: 'POST'
};

export default function registerEvent({ eventName, payload }) {
    const url = `${ENDPOINT}/${eventName}`;
    const options = {
        ...REQUEST_OPTIONS,
        body: JSON.stringify(payload)
    };

    doRecursiveFetch(url, options, RETRY_LIMIT)
        .then(response => validateResponse(response))
        .catch(error => handleError(error));
}

function validateResponse(response) {
    if (!response.ok) {
        throw Error(response.statusText);
    }

    return response;
}

function handleError(error) {
    console.error(error);
}

function doRecursiveFetch(url, options, limit) {
    return fetch(url, options).then(response => {
        if (!response.ok && limit > 0) {
            limit -= 1;

            return doRecursiveFetch(url, options, limit);
        }

        return response;
    });
}
